document.addEventListener('DOMContentLoaded', function() {

    let searchButtons = document.querySelectorAll('.header--bottom-row--search__button');
    let searchInputs = document.querySelectorAll('.header--bottom-row--search__input');
    if (searchButtons.length > 0 && searchInputs.length > 0) {
        searchButtons.forEach(function(searchButton) {
            let searchInput = searchButton.closest('form').querySelector('.header--bottom-row--search__input');
            searchButton.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                searchInput.classList.toggle('header--bottom-row--search__input--visible');
                searchButton.classList.toggle('header--bottom-row--search__button--hidden');
                return false;
            });
        });
        
        searchInputs.forEach(function(searchInput) {
            searchInput.addEventListener('keydown', function(event) {
                if (event.type === 'keydown' && event.key === 'Enter') {
                    event.preventDefault();
                    event.stopPropagation();
                    searchInput.closest('form').submit();
                    return false;
                }
            });
        });

        document.addEventListener('click', function(e) {
            if (e.target.closest('.header--bottom-row--search__input')) {
                return;
            }
            searchInputs.forEach(function(searchInput) {
                searchInput.classList.remove('header--bottom-row--search__input--visible');
            });
            searchButtons.forEach(function(searchButton) {
                searchButton.classList.remove('header--bottom-row--search__button--hidden');
            });
        });
    }

    let filterButton = document.querySelector('.navigation--button[data-toggle-menu="refine-filter"]');
    let filterMenu = document.querySelector('.off-canvas--container__custom');
    if (!!filterButton && !!filterMenu) {
        filterMenu.style.setProperty('--menu-height', filterMenu.scrollHeight + 'px');
    
        filterButton.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            filterMenu.classList.toggle('off-canvas--container__custom--visible');
            return false;
        });
    
        let filterCategories = document.querySelectorAll('.filter--category');
        filterCategories.forEach(function(filterCategory) {
            let filterCategoryButton = filterCategory.querySelector('.filter--toggle');
            let filterCategoryContent = filterCategory.querySelector('.filter--menu');
            filterCategoryContent.style.setProperty('--menu-height', filterCategoryContent.scrollHeight + 'px');
    
            filterCategoryButton.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                filterCategoryContent.classList.toggle('filter--menu__visible');
                if (filterCategoryContent.classList.contains('filter--menu__visible')) {
                    filterMenu.style.setProperty('--menu-height', filterMenu.scrollHeight + filterCategoryContent.scrollHeight + 'px');
                } else {
                    filterMenu.style.setProperty('--menu-height', filterMenu.scrollHeight - filterCategoryContent.scrollHeight + 'px');
                }
                return false;
            });
        });
    
        document.addEventListener('theme:filters:updated', function(e) {
            let { body_html } = e.detail;
            let filterTags = document.querySelectorAll('.filter--link[data-type="refine"] input');
            filterTags.forEach(function(filterTag) {
                let filterTagValue = filterTag.value;
                let correspondingFilter = body_html.find(`.filter--link[data-type="refine"] input[value="${filterTagValue}"]`).closest('.filter--link').data('count');
                let parentFilter = filterTag.closest('.filter--link');
                if (parentFilter) {
                    parentFilter.dataset.count = correspondingFilter;
                    if (correspondingFilter > 0 || filterTag.checked) {
                        parentFilter.classList.remove('filter--link__disabled');
                    } else {
                        parentFilter.classList.add('filter--link__disabled');
                    }
                }
            });
                
        });;
    
        let realClearButton = document.querySelector('.navigation--active-clear:not(.navigation--active-clear__custom)');
        let clearButton = document.querySelector('.navigation--active-clear__custom');
        if (clearButton) {
            clearButton.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                realClearButton.click();
                window.scrollTo(0, 0);
                return false;
            });
        }
    }

    let customOrderPage = document.querySelector('.order-summary');
    let tableRowPlaceholder = document.querySelector('.order-summary__table-row--placeholder');
    let orderCustomerName = document.querySelector('.order-summary__name');
    let orderTailorName = document.querySelector('.order-summary__tailor-name');
    let orderItemsTable = document.querySelector('.order-summary__table');
    let orderStatus = document.querySelector('.order-summary__status');
    let orderETATitle = document.querySelector('.order-summary__eta-title');
    let orderETA = document.querySelector('.order-summary__eta');
    let mainContent = document.querySelector('.page--custom-order-status');

    const statusTexts = {
        'in-progress': 'Order In Progress',
        'ready': 'Ready to collect',
        'completed': 'Contact Us',
    }


    const initOrderSummary = async (orderId, orderSummaryEl) => {
        let response = await fetch(`https://api.pjt.com/api/ticktock/order/${orderId}`, {
            headers: {
                'Auth-Token': 'D;g?JLgz<O>Wjyt`MF~sPJ8-1w@2M<EU,4d/_QjrZvm$mdyu0OG:{y:5y,*7Mh5A'
            }
        });
        let order = await response.json();
        if (order.errorKey == 'error') {
            mainContent.classList.add('page--custom-order-status--empty');
            return;
        }

        mainContent.classList.remove('page--custom-order-status--empty');
        orderCustomerName.innerHTML = order.data.customerName;
        orderTailorName.innerHTML = order.data.tailorName;
        let tailorImage = document.querySelector(`.order-summary__tailor-image[data-tailor="${order.data.tailorName}"]`);
        if (tailorImage) {
            tailorImage.classList.add('order-summary__tailor-image--visible');
        } else {
            document.querySelector('.order-summary__tailor-image').classList.add('order-summary__tailor-image--visible');
        }

        order.data.orderProducts.forEach(function(orderProduct) {
            let tableRow = tableRowPlaceholder.cloneNode(true);
            let productType = orderProduct.productType.toUpperCase();
            tableRow.classList.remove('order-summary__table-row--placeholder');
            tableRow.querySelector('[data-order]').innerHTML = orderProduct.productNumber;
            tableRow.querySelector('[data-item]').innerHTML = `
                <div class="order-summary__table-row-cell__code">${orderProduct.productNumber}</div>
                ${productType}, ${orderProduct.productFabric}
            `;

            console.log(orderProduct.productStatus);
            tableRow.querySelector('.order-summary__table-row-cell__status').dataset.status = orderProduct.productStatus;
            tableRow.querySelector('.order-summary__table-row-cell__status').setAttribute('data-status', orderProduct.productStatus);
            orderItemsTable.appendChild(tableRow);
            console.log(tableRow, tableRow.querySelector('.order-summary__table-row-cell__status').dataset.status);
        });
        let orderStatusText = statusTexts[order.data.orderStatus];
        orderStatus.innerHTML = orderStatusText;
        
        if (order.data.orderStatus === 'completed') {
            orderStatus.href = '/pages/contact';
        } else {
            orderStatus.removeAttribute('href');
        }
        
        customOrderPage.dataset.state = order.data.orderStatus;

        if (order.data.orderExpectedAt && order.data.orderStatus == 'in-progress') {
            orderETATitle.classList.remove('visually-hidden');
            orderETA.innerHTML = order.data.orderExpectedAt
        } else {
            orderETATitle.classList.add('visually-hidden');
        }

        if (order.data.orderStatus === 'completed') {
            orderStatus.classList.add('order-summary__status--completed');
        }
    }

    if (customOrderPage) {
        let urlParams = new URLSearchParams(window.location.search);
        let orderNumber = urlParams.get('id');  
        initOrderSummary(orderNumber, customOrderPage);
    }
});


(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],al=w.atob,
j=d.createElement(s),jl=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'',p=d.location.pathname;jl.async=true;
j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
})(window,document,'script','dataLayer','GTM-W2CFM99');